import React,{useState} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {Owner} from './Inc';
import {Theme} from './Theme';
import {Tools} from './Tools';
import Logo from './Logo';
import ChangeOwner from './ChangeOwner';
import Commissions from './Commissions';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';

import useStyles from './Styles';

interface HeaderProps {
    owner: Owner,
	managerId: number,
	comissions():void,
	onClickDrawer():void,
	onClickPersonMenu():void,
	changeOwner(switchId:number):void,
}

const Header:React.FC<HeaderProps> = (props)=> {
	const classes = useStyles();
	const [states,setStates] = useState({
		isOwners:false,
		isCommisions:false,
	});
	const openOwners = ()=>{
		setStates({...states,isOwners:true});
	}
	const closeOwners = ()=>{
		setStates({...states,isOwners:false});
	}
	const changeOwner = (switchId:number,isNew:boolean)=>{
		setStates({...states,isOwners:false});
		props.changeOwner(switchId);
	}
	const openCommissions = ()=>{
		setStates({...states,isCommisions:true});
	}
	const closeCommissions = ()=>{
		setStates({...states,isCommisions:false});
	}

	let profileIcon = (null);
	if( props.owner.owner_id>0 && props.owner.img_id>0 ){
		profileIcon = <Avatar src={Tools.getStoreImg(props.owner.owner_id,props.owner.img_id)} sx={{ width: 30, height: 30 }}/>
	} else if(props.owner.switch_id===1) {
		profileIcon = <LooksOneIcon sx={{ width: 38, height: 38 }} color="secondary"/>
	} else if(props.owner.switch_id===2) {
		profileIcon = <LooksTwoIcon sx={{ width: 38, height: 38 }} color="secondary"/>
	} else if(props.owner.switch_id===3) {
		profileIcon = <Looks3Icon sx={{ width: 38, height: 38 }} color="secondary"/>
	} else if(props.owner.switch_id===4) {
		profileIcon = <Looks4Icon sx={{ width: 38, height: 38 }} color="secondary"/>
	} else if(props.owner.switch_id===5) {
		profileIcon = <Looks5Icon sx={{ width: 38, height: 38 }} color="secondary"/>
	} else {
		profileIcon = <PersonIcon sx={{ width: 38, height: 38 }} color="info"/>
	}
	//console.log(typeof props.owner.switch_id);

	return (
		<>
		<AppBar position="fixed" className={classes.appbar} style={{zIndex:Theme.zIndex.drawer+1}}>
			<Toolbar variant="dense" className={classes.toolbar}>
				<Box sx={{display:{lg:'none',md:'block'}}}>
					<IconButton className={classes.menuButton} color="primary" aria-label="Menu" onClick={props.onClickDrawer}>
						<MenuIcon/>
					</IconButton>
				</Box>
				<Logo/>
				{props.owner.isLogined ? (
				<Box className={classes.person}>
					<IconButton size="small" color="inherit" onClick={openOwners}>
						{profileIcon}
					</IconButton>
					<IconButton className={classes.personButton} color="primary" aria-label="logined" onClick={props.onClickPersonMenu}>
						<AccountBoxIcon sx={{ width: 38, height: 38 }}/>
					</IconButton>
				</Box>
				):(
				<Box className={classes.person}>
					<Link to="/login"><Button variant="outlined"><PersonIcon/>ログイン</Button></Link>
				</Box>
				)}
			</Toolbar>
		</AppBar>
		<ChangeOwner isOpen={states.isOwners} close={closeOwners} change={changeOwner} customerId={props.owner.customer.customer_id} comissions={openCommissions}/>
		<Commissions close={closeCommissions} owner={props.owner} isOpen={states.isCommisions}/>
		</>
	)
}

export default Header;